import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect } from "react";
import SuccessIcon from "../../images/success.svg";
import ErrorIcon from "../../images/noItem.svg";
import CloseBtn from "../../images/closeBtn.svg";

export default function FoodCustomAlert(props) {
  function closeModal() {
    props.hide();
  }

  useEffect(()=>{
    console.log(props?.msgtype)
  },[props])
  return (
    <>
      <Transition appear show as={Fragment}>
        <Dialog as="div" className="relative z-[999999]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all relative">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <button
                      onClick={closeModal}
                      className="absolute top-3 right-4"
                    >
                      <img className="w-3 h-3" src={CloseBtn} alt="" />
                    </button>
                    {props.msgtype === "success" && (
                      <div className="flex flex-col gap-2 w-full  items-center justify-center">
                        <div>
                          <img className="w-16 h-16" src={SuccessIcon} alt="" />
                        </div>
                        <div>Your Order placed successfully</div>
                      </div>
                    )}
                    {props.msgtype === "error" && (
                      <div className="flex flex-col gap-2 w-full  items-center justify-center">
                        <div>
                          <img className="w-16 h-16" src={ErrorIcon} alt="" />
                        </div>
                        <div>Some thing went wrong</div>
                      </div>
                    )}
                     {props.msgtype !== "error" && props.msgtype !== "mismatch" &&  props.msgtype !== "roomNotAssigned" && props.msgtype !== "info" && props.msgtype !== "roomNotAssigned" && props.msgtype && props.msgtype !== "success" &&( 
                      <div className="flex flex-col gap-2 w-full  items-center justify-center">
                        <div>
                          <img className="w-16 h-16" src={ErrorIcon} alt="" />
                        </div>
                        <div>{props.msgtype}</div>
                      </div>
                    )}
                    {props.msgtype === "mismatch" && (
                      <div className="flex flex-col gap-2 w-full  items-center justify-center">
                        <div>
                          <img className="w-16 h-16" src={ErrorIcon} alt="" />
                        </div>
                        <div>Enter correct Room Numbers</div>
                      </div>
                    )}
                    {props.msgtype === "roomNotAssigned" && (
                      <div className="flex flex-col gap-2 w-full  items-center justify-center">
                        <div>
                          <img className="w-16 h-16" src={ErrorIcon} alt="" />
                        </div>
                        <div>Room number is not assigned yet</div>
                      </div>
                    )}
                    {props.msgtype === "info" && (
                      <div className="flex flex-col gap-2 w-full  items-center justify-center">
                        <div className="flex w-full text-base font-semibold">
                          Kindly proceed by downloading the app.
                        </div>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            If you have multiple room bookings under your
                            booking id, please proceed by downloading the app.
                          </p>
                        </div>
                      </div>
                    )}
                    {props.msgtype === "info" && (
                      <div className="w-full flex justify-end mt-3">
                        <button
                          type="button"
                          className="inline-flex justify-end rounded-md border border-transparent bg-[#3d38af] px-4 py-2 text-sm font-medium text-white hover:bg-blue-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                          onClick={closeModal}
                        >
                          ok thanks
                        </button>
                      </div>
                    )}
                  </Dialog.Title>
                  <div className="mt-2  w-full flex justify-end items-center confirm-order">
                    <div className="flex items-center gap-3"></div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
